import { useState } from "react";
import InputWithLabel from "./InputWithLabel";
import Button from "../buttons/button";
import SelectBox from "./SelectBox ";
import useTranslator from "../../../hooks/useTranslator";

const initialFormData = {
  status_updated_at: "",
  packing_type: "",
  status: ""
};

const BrokerageRefrigerationFilter = ({ onApplyFilter, onClose, filters = {} }) => {

    const [filtersData, setFiltersData] = useState({
      status_updated_at: filters.status_updated_at || "",
      packing_type: filters.packing_type || "",
      status: filters.status || ""
    });
    const { _t } = useTranslator();
    
    const status = [
        {
            label: _t("stored", "Stored"),
            value: "stored",
        },
        {
            label: _t("sold", "Sold"),
            value: "sold",
        }
    ];

    const packingTypeOptions = [
      { value: "prime_cheek_10_pounds", label: _t("prime_cheek_10_pounds", "Prime Cheek - 10 Pounds") },
      { value: "prime_cheek_20_pounds", label: _t("prime_cheek_20_pounds", "Prime Cheek - 20 Pounds") },
      { value: "prime_strip_20_pounds", label: _t("prime_strip_20_pounds", "Prime Strip - 20 Pounds") },
      { value: "seconds_cheeks_20_pounds", label: _t("seconds_cheeks_20_pounds", "Seconds Cheeks - 20 Pounds") },
      { value: "seconds_strips_20_pounds", label: _t("seconds_strips_20_pounds", "Seconds Strips - 20 Pounds") },
      { value: "seconds_tapitas_20_pounds", label: _t("seconds_tapitas_20_pounds", "Seconds Tapitas - 20 Pounds") },
      { value: "seconds_pieces_20_pounds", label: _t("seconds_pieces_20_pounds", "Seconds Pieces - 20 Pounds") },
    ];


    const handleChange = (e) => {
        let { name, value } = e.target;
        setFiltersData({ ...filtersData, [name]: value });
    };

  const handleReset = (e) => {
    e.preventDefault();
    setFiltersData(initialFormData);
    onApplyFilter(initialFormData);
    if (onClose) {
      onClose();
    }
  };

  const handleApply = (e) => {
    e.preventDefault();
    onApplyFilter({ ...filtersData });
    if (onClose) {
      onClose();
    }
  };


  return (
    <div className="dropdown_body">
        <h5 className="mb-3 border-bottom">{_t("filter_heading", "Filter")}</h5>

        <InputWithLabel
          label={_t("updated_at", "Updated at")}
          type="date"
          name="status_updated_at"
          value={filtersData.status_updated_at}
          onChange={handleChange}
        />

        <SelectBox
          label={_t("packing_type", "Packing Type")}
          name="packing_type"
          value={filtersData.packing_type}
          onChange={handleChange}
          options={packingTypeOptions?.map((list) => ({
              value: list.value,
              label: list.label,
          }))}
        />

        <SelectBox
            label={_t("status", "Status")}
            name="status"
            value={filtersData.status}
            onChange={handleChange}
            options={status?.map((list) => ({
                value: list.value,
                label: list.label,
            }))}
        />


      <div className="d-flex justify-content-between mt-3">
        <Button
          onClick={handleReset}
          label={_t("reset_button", "Reset")}
          className="reset_btn"
        />
        <Button
          className="cmn_btn"
          label={_t("apply_button", "Apply")}
          onClick={handleApply}
        />
      </div>
    </div>
  );
};

export default BrokerageRefrigerationFilter;
